"use client";

import { chatSpacing, colors } from "@/styles/design-tokens";

export interface SearchChipProps {
  searchTool: { searchId?: string; searchText: string; label: string };
  isLoading: boolean;
  isActive: boolean;
  isFirstLoading?: boolean;
  onClick: () => void;
}

export function SearchChip({
  searchTool,
  isLoading,
  isActive,
  isFirstLoading = false,
  onClick,
}: SearchChipProps) {
  const textColor = isActive ? colors.stroke.pureBlack : colors.text.softestBlack;

  // First loading chip gets shimmer (active), others get opacity pulse (queued)
  const loadingClass = isLoading
    ? isFirstLoading
      ? "skeleton-shimmer" // Active shimmer for first
      : "search-chip-pulse" // Subtle pulse for others
    : "hover:bg-gray-100";

  return (
    <button
      type="button"
      data-testid="search-chip"
      onClick={onClick}
      disabled={isLoading}
      className={`flex min-w-0 w-full items-center gap-2 rounded-lg py-3.5 text-left text-sm transition-all ${loadingClass}`}
      style={{
        paddingLeft: chatSpacing.chipPaddingX,
        paddingRight: chatSpacing.chipPaddingX,
        backgroundColor: isFirstLoading
          ? undefined // Let skeleton-shimmer handle background
          : isActive
            ? colors.accent.lightestGray
            : colors.background.white,
        border: isLoading
          ? "1px dashed #d1d5db" // Dashed border for ALL loading chips
          : `1px solid ${isActive ? colors.stroke.pureBlack : colors.divider.default}`,
        cursor: isLoading ? "default" : "pointer",
      }}
    >
      <span
        className={`truncate ${isActive ? "font-semibold" : "font-medium"}`}
        style={{ color: isLoading ? colors.text.grayLightest : textColor }}
      >
        {isLoading ? `Searching for ${searchTool.searchText}...` : searchTool.label}
      </span>
    </button>
  );
}
